import {Directive, ElementRef, Input, OnInit, Renderer2} from '@angular/core';
import {AbstractControl, UntypedFormGroup, Validators} from '@angular/forms';

@Directive({
  selector: '[appMarkAsterisk]',
})
export class MarkAsteriskDirective implements OnInit {
  public isTouched?: boolean;
  @Input() formGroup!: UntypedFormGroup;
  @Input() hasMark: boolean = true;
  @Input() controlName!: string;
  @Input() set touched(value: boolean) {
    this.isTouched = value;
    if (value) this.checkIfValid();
  }

  constructor(private elementRef: ElementRef, private renderer: Renderer2) {}

  ngOnInit(): void {
    this.setAsteriskMark();
    this.control.valueChanges.subscribe(() => {
      this.checkIfValid();
      this.setAsteriskMark();
    });
  }

  checkIfValid() {
    const req = this.control!.invalid;
    if (req && this.isTouched) {
      this.renderer.addClass(this.elementRef.nativeElement, 'required-error');
    } else {
      this.renderer.removeClass(
        this.elementRef.nativeElement,
        'required-error'
      );
    }
  }

  setAsteriskMark() {
    const asterisk = this.control.hasValidator(Validators.required);
    const nativeElement = this.elementRef.nativeElement;
    const hasAsterisk = nativeElement.innerHTML.includes('*');

    if (asterisk && this.hasMark && !hasAsterisk) {
      nativeElement.append('*');
    } else if (!asterisk && hasAsterisk) {
      nativeElement.innerHTML = nativeElement.innerHTML.replace('*', '');
    }
  }

  get control(): AbstractControl {
    return this.formGroup.controls[this.controlName];
  }
}
